import type { ReactElement } from 'react'
import { TextInput } from '@mantine/core'
import { useTranslation } from '@front/model'
import { usePreferenceContext } from './Context'

export const PreferenceSearchInput = (): ReactElement => {
  const { t } = useTranslation()
  const { filter, setFilter } = usePreferenceContext()
  return <TextInput placeholder={t('Search')} value={filter} onChange={(e) => setFilter(e.currentTarget.value)} />
}
